import { z } from 'zod';
import { requiredUuidString } from '../zod-helpers/index.js';
import { PROMOTION_CREDIT_CONSTRAINTS } from './constraints.js';
import { hasAtMostDecimalPlaces } from './has-at-most-decimal-places.js';
import { lowercaseUuid } from './lowercase-uuid.js';
const MAX_LINE_NUMBER = 1_000_000_000;
const { decimals, percentageDecimals } = PROMOTION_CREDIT_CONSTRAINTS.lines;
const placesMessage = (label, places) => `${label} can have at most ${places} decimal places.`;
/** The fields every credit line carries, shared by the issue and update line schemas. */
export const lineShape = {
    productTreeId: requiredUuidString('Category is required.', 'Invalid category selection.').transform(lowercaseUuid),
    quantity: z
        .number({ error: 'Quantity is required.' })
        .positive('Quantity must be greater than 0.')
        .max(MAX_LINE_NUMBER, `Quantity must be ${MAX_LINE_NUMBER.toLocaleString()} or less.`)
        .refine((value) => hasAtMostDecimalPlaces(value, decimals), {
        message: placesMessage('Quantity', decimals),
    }),
    unitPrice: z
        .number({ error: 'Unit price is required.' })
        .nonnegative('Unit price cannot be negative.')
        .max(MAX_LINE_NUMBER, `Unit price must be ${MAX_LINE_NUMBER.toLocaleString()} or less.`)
        .refine((value) => hasAtMostDecimalPlaces(value, decimals), {
        message: placesMessage('Unit price', decimals),
    }),
    percentageOff: z
        .number({ error: 'Percentage off is required.' })
        .min(0, 'Percentage off must be between 0 and 100.')
        .max(100, 'Percentage off must be between 0 and 100.')
        .refine((value) => hasAtMostDecimalPlaces(value, percentageDecimals), {
        message: placesMessage('Percentage off', percentageDecimals),
    }),
    customerPaid: z
        .number({ error: 'Customer paid is required.' })
        .nonnegative('Customer paid cannot be negative.')
        .max(MAX_LINE_NUMBER, `Customer paid must be ${MAX_LINE_NUMBER.toLocaleString()} or less.`)
        .refine((value) => hasAtMostDecimalPlaces(value, decimals), {
        message: placesMessage('Customer paid', decimals),
    }),
};
//# sourceMappingURL=line-shape.js.map